
const FinanceDashboardPage = () => {
  

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-white">Financial Dashboard</h1>
          <p className="text-sm text-slate-400">Coming Soon!</p>
        </div>
      </div>
    </div>
  );
};

export default FinanceDashboardPage;
